import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const ChevronDownIcon = forwardRef<SVGSVGElement, IconProps>(function ChevronDownIcon(
  { color, height = 18, width = 18, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.89881 7.38956C6.01943 7.27253 6.21499 7.27253 6.3356 7.38956L8.9999 9.97456L11.6642 7.38956C11.7848 7.27253 11.9804 7.27253 12.101 7.38956C12.2216 7.50659 12.2216 7.69633 12.101 7.81335L9.2183 10.6102C9.09768 10.7273 8.90212 10.7273 8.78151 10.6102L5.89881 7.81335C5.77819 7.69633 5.77819 7.50659 5.89881 7.38956Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.6788 7.17609C5.92092 6.94117 6.31349 6.94117 6.55562 7.17609L8.9999 9.54762L11.4442 7.17609C11.6863 6.94117 12.0789 6.94117 12.321 7.17609C12.5631 7.41101 12.5631 7.7919 12.321 8.02682L9.43831 10.8237C9.19619 11.0586 8.80362 11.0586 8.56149 10.8237L5.6788 8.02682C5.43667 7.7919 5.43667 7.41101 5.6788 7.17609ZM8.82093 10.2216L8.9999 10.3952L9.17888 10.2216C9.07187 10.2947 8.92794 10.2947 8.82093 10.2216Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.48883 7.24881C6.28419 7.05027 5.95022 7.05027 5.74559 7.24881C5.54413 7.44427 5.54413 7.75865 5.74559 7.9541L8.62828 10.751C8.83292 10.9495 9.16689 10.9495 9.37152 10.751L12.2542 7.9541C12.4557 7.75865 12.4557 7.44427 12.2542 7.24881C12.0496 7.05027 11.7156 7.05027 11.511 7.24881L9.06669 9.62034C9.0292 9.65672 8.97061 9.65672 8.93311 9.62034L6.48883 7.24881ZM5.61201 7.10338C5.89163 6.83208 6.34279 6.83208 6.62241 7.10338L8.9999 9.4101L11.3774 7.10338C11.657 6.83208 12.1082 6.83208 12.3878 7.10338C12.6706 7.37776 12.6706 7.82515 12.3878 8.09954L9.5051 10.8964C9.22548 11.1677 8.77432 11.1677 8.4947 10.8964L5.61201 8.09954C5.3292 7.82515 5.3292 7.37776 5.61201 7.10338ZM6.26881 7.46228C6.18569 7.38163 6.04873 7.38163 5.9656 7.46228C5.88566 7.53984 5.88566 7.66307 5.9656 7.74064L8.8483 10.5375C8.93142 10.6182 9.06838 10.6182 9.15151 10.5375L12.0342 7.74064C12.1141 7.66307 12.1141 7.53984 12.0342 7.46228C11.9511 7.38163 11.8141 7.38163 11.731 7.46228L9.06669 10.0473C9.0292 10.0836 8.97061 10.0836 8.93311 10.0473L6.26881 7.46228ZM5.83202 7.31684C5.99013 7.16344 6.24428 7.16344 6.4024 7.31684L8.9999 9.83704L11.5974 7.31684C11.7555 7.16344 12.0097 7.16344 12.1678 7.31684C12.3291 7.47333 12.3291 7.72958 12.1678 7.88607L9.28509 10.683C9.12698 10.8364 8.87283 10.8364 8.71471 10.683L5.83202 7.88607C5.67073 7.72958 5.67073 7.47333 5.83202 7.31684ZM8.74477 10.1593C8.77623 10.1187 8.83274 10.1095 8.87482 10.1383C8.94919 10.1892 9.05062 10.1892 9.12498 10.1383C9.16706 10.1095 9.22357 10.1187 9.25503 10.1593C9.28649 10.2 9.28242 10.2586 9.24567 10.2943L9.06669 10.4679C9.0292 10.5043 8.97061 10.5043 8.93311 10.4679L8.75414 10.2943C8.71738 10.2586 8.71332 10.2 8.74477 10.1593Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
